<template>
  <section>
    <!-- BEGIN PORTAL CONTEXT CTA -->
    <div class="card cta box-shadow" v-if="!showSearch">
      <h5 class="text-center">{{ prompt }}</h5>
      <button
        class="btn --sm"
        @click.stop="openGroupSelector(tabToOpen)"
        @keydown.13="openGroupSelector(tabToOpen)"
      >
        Select Now!
      </button>
    </div>
    <!-- END PORTAL CONTEXT CTA -->
    <div class="">
      <div class="blurred-overlay">
        <div>
          <v-data-table
            :headers="headers"
            :items="desserts"
            class="v-table-wrapper"
            :class="modifier"
            hide-actions
          >
            <template #items="props" >
              <td>{{ props.item.name }}</td>
              <td class="text-xs-right">{{ props.item.calories }}</td>
              <td class="text-xs-right">{{ props.item.fat }}</td>
              <td class="text-xs-right">{{ props.item.carbs }}</td>
              <td class="text-xs-right">{{ props.item.protein }}</td>
              <td class="text-xs-right">{{ props.item.iron }}</td>
            </template>
          </v-data-table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { computed, onBeforeMount } from '@vue/composition-api';
  import { useGroupSelector } from '@composables/useGroupSelector';
  import { useRoute } from '@vue3shims';
  export default {
    setup() {
      const route = useRoute();
      const { openGroupSelector, showSearch, userHasOneParent, isBillingOverviewPage } = useGroupSelector();
      const prompt = computed(() => {
        if (isBillingOverviewPage.value === true || route.name === 'billing-payment-history' ) {
          return 'Select a parent group to continue.'
        } else if (userHasOneParent.value === true) {
          return 'Select a group and subgroup to continue.'
        }
        return 'Select a parent group, group and subgroup to continue.'
      });

      const tabToOpen = computed(() => {
        if(userHasOneParent.value) {
          return 'group';
        }
        return 'parentGroup';
      })

      // onBeforeMount(() => {
      //   console.log(`PortalContextCTA OBM: ${ showSearch.value }`);
      // })

      return {
        openGroupSelector,
        prompt,
        showSearch,
        tabToOpen,
      }
    },
    props: ['modifier'],
    data() {
      return {
        headers: [
          {
            text: 'Ipsum',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          { text: 'Lorum', value: 'calories' },
          { text: 'Dolor', value: 'fat' },
          { text: 'Sit', value: 'carbs' },
          { text: 'Ipsum', value: 'protein' },
          { text: 'Dolor', value: 'iron' }
        ],
        desserts: [
          {
            name: 'Lorum',
            calories: 159,
            fat: 6.0,
            carbs: 24,
            protein: 4.0,
            iron: '1%'
          },
          {
            name: 'Ipsum',
            calories: 237,
            fat: 9.0,
            carbs: 37,
            protein: 4.3,
            iron: '1%'
          },
          {
            name: 'Dolor',
            calories: 262,
            fat: 16.0,
            carbs: 23,
            protein: 6.0,
            iron: '7%'
          },
          {
            name: 'Sit',
            calories: 305,
            fat: 3.7,
            carbs: 67,
            protein: 4.3,
            iron: '8%'
          },
          {
            name: 'Lorum',
            calories: 356,
            fat: 16.0,
            carbs: 49,
            protein: 3.9,
            iron: '16%'
          }
        ]
      }
    }
  }
</script>
<style scoped>
section {
  height: 400px;
  max-height: 400px;
  width: 100%;
  padding: 0;
  background: #fafafa;
  position: relative;
}

.cta {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-60%);
  z-index: 100;
  background: white;
  border: 1px solid #c0c0c0;
  padding: 2rem;
  max-width: 400px;
}

.blurred-overlay-wrapper {
  position: relative;
  height: 100%;
  max-height: 100%;
  background: #fafafa;
}

/* hide for ie11 */
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .blurred-overlay {
    opacity: 0.0;
  }
}

.blurred-overlay {
  -webkit-filter: blur(3px);
  -moz-filter: blur(3px);
  -o-filter: blur(3px);
  -ms-filter: blur(3px);
  filter: blur(3px);

  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafafa;
  cursor: pointer;
}
.v-table-wrapper {
  padding: 0 !important;
  width: 100%;
}
</style>
